import { useLayoutEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FooterLogo from "../components/FooterLogo";
import FormObserver from "../components/FormElements/FormObserver";
import { Form, Formik } from "formik";
import { object, ref, string } from "yup";
import { FormInput } from "../components/FormElements";
import { Button } from "../components/Elements";
import ReCAPTCHA from "react-google-recaptcha";
import commonNetwork from "../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet";
import Loading from "../components/Loading";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";

type FormProps = {
    password: string,
    confirmPassword: string,
}

const ResetPassword = () => {

    const { firmInformations } = useRecoilValue(tenantState);
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate()

    const [loading, setLoading] = useState(true);
    const [verifyCheckError, setVerifyCheckError] = useState("");
    const [resetLoading, setResetLoading] = useState(false);
    const recaptchaRef = useRef<any>();
    const [capthaLoad, setCapthaLoad] = useState(false);
    const verifyCode = searchParams.get("verify");

    setTimeout(() => {
        setCapthaLoad(true);
    }, 500);

    useLayoutEffect(() => {
        controlVerify();
    }, []);

    const controlVerify = async () => {

        const params = {
            code: verifyCode
        }

        const result = await commonNetwork.get("/token/check-verify-code", params);
        const { data, isSuccess, errorMessage } = result;


        setLoading(false);
        if (isSuccess) {
            setVerifyCheckError("");
        } else {
            setVerifyCheckError(result.errorMessage || "Şifre sıfırlama kodu bulunamadı. Lütfen yetkili ile iletişime geçiniz.");
        }
    }

    const onSubmit = async (values: FormProps) => {
        setResetLoading(true);

        const params = {
            firmcode: firmInformations.firmCode,
            password: values.password,
            verifyCode: verifyCode
        }
        const result = await commonNetwork.post("/token/reset-password", params);
        const { data, isSuccess, errorMessage } = result;

        setResetLoading(false);
        if (isSuccess) {
            toast.success("Şifreniz başarılı bir şekilde yenilenmiştir. \nGiriş sayfasına yöneldiriliyorsunuz...");
            setTimeout(() => {
                navigate("/" + firmInformations.firmPath + "/login");
            }, 3000);
        } else {
            toast.error(errorMessage);
        }
    }

    const initialValues = {
        password: "",
        confirmPassword: ""
    }

    const filtersSchema = object({
        password: string().required("Lütfen Yeni Şifreyi giriniz.").min(6, "Şifreniz minimum 6 karakter olmalıdır")
            .max(30, "Şifreniz maksimum 30 karakter olmalıdır"),
        confirmPassword: string().required("Lütfen Yeni Şifreyi tekrar giriniz.").oneOf([ref('password'), null], 'Şifreler aynı olmalıdır')
            .min(6, "Şifreniz minimum 6 karakter olmalıdır").max(30, "Şifreniz maksimum 30 karakter olmalıdır"),
    });

    if (loading) {
        return (
            <Loading />
        );
    }

    return (
        <div className="flex flex-col md:flex-row h-screen items-center">

            <Helmet title={`Şifremi Sıfırla`}
            >

            </Helmet>
            <div className="lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
                <img src="/images/logopng.svg" className="w-full h-full object-cover" alt="Sample image" />
            </div>
            <div className="w-full md:w-1/3 right-side mb-4">


                <div className="max-[33%]">
                </div>
                <div className="px-6 lg:px-12 xl:px-10 text-center md:text-right justify-center md:justify-end">
                    <div className="text-center mb-8">
                        <img className="mx-auto w-48" src={`https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/${firmInformations.logoPath}`} alt="logo" />

                    </div>


                    <div className="flex flex-row items-center justify-center lg:justify-center mb-8 ">
                    </div>
                    <div className="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
                        <p className="text-center font-semibold mx-4 mb-0">Şifremi Sıfırla</p>
                    </div>
                    {verifyCheckError?.length > 0 ? (
                        //     <div className="text-danger  text-sm text-center">
                        //     {verifyCheckError}
                        // </div>
                        <div className="bg-error-10  p-1 rounded-md  w-full text-error-dark text-center inline-block px-3 py-4 "
                            role="alert">
                            <div className="flex justify-center">
                                <div>
                                    <p className="font-semibold text-lg "> {verifyCheckError}</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="mb-8">

                            <Formik
                                validationSchema={filtersSchema}
                                enableReinitialize
                                onSubmit={onSubmit}
                                initialValues={initialValues}
                            >
                                {formProps => (
                                    <Form>
                                        <FormObserver watch={() => {

                                        }} />
                                        <div className="flex flex-col sm:text-left lg:text-center justify-start mt-3">
                                            <input type="hidden" name="CaptchaToken" id="CaptchaToken" value="" />


                                            <div className=" mt-3">
                                                <div className="w-full relative">
                                                    <FormInput
                                                        label="Yeni Şifre*"
                                                        name="password"
                                                        type="password"
                                                    />
                                                </div>
                                            </div>
                                            <div className=" mt-3">
                                                <div className="w-full relative">
                                                    <FormInput
                                                        label="Yeni Şifre Tekrar*"
                                                        name="confirmPassword"
                                                        type="password"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-center lg:text-center mb-4">
                                            <Button
                                                type="submit"
                                                color="primary"
                                                hover="primary"
                                                className={" w-full h-12 mt-6 px-7 py-3"}
                                                size="xl"
                                                disabled={resetLoading}
                                                loading={resetLoading}
                                            >
                                                Onayla
                                            </Button>

                                        </div>

                                    </Form>
                                )}
                            </Formik>

                        </div>
                    )}

                </div>
                {capthaLoad && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LewgCwmAAAAAD6pjQQbOP9Dxq7AC025wgOuNZDb"
                    />
                )}
                <div className="flex items-endflex items-end justify-center ">
                    <FooterLogo />
                </div>
            </div>
        </div>
    );
}
export default ResetPassword;